import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * RiskRecordTagUnassignment
 *
 * Unassign user created tags from a risk record.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const RiskRecordTagUnassignment = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': `/risk-records/${thePayload?.eid}/unassign/${thePayload?.tagCode}`,
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/mutations/RiskRecordTagUnassignment.js -> RiskRecordTagUnassignment()',
      false,
      error
    );

    throw error;
  }
};
